export default __webpack_public_path__ + "static/media/trophy.6a023eec.svg";